import notFound from "@/app/not-found";
import { ProductCardCarousel } from "@frontend/components/productCardCarousel/ProductCardCarousel";
import {
  getCategories,
  getProductsByCategoryId,
} from "@frontend/lib/actions/actions";
import { getOrganizationAssetsForOrg } from "@frontend/lib/actions/config-actions";
import { getOrgDataFromOrgTitle } from "@frontend/lib/actions/market-graphql-queries";

export async function CardCarouselComponent({
  style,
  params,
  props,
}: {
  params: { clientSlug: string; orgId: number };
  props: { categoryName: string; showIcon?: boolean; iconURL?: string };
  style: string;
}) {
  const organization = await getOrgDataFromOrgTitle(
    params.clientSlug.toUpperCase(),
  );
  const orgId = organization.findFirstOrganization?.id;

  // Org does not exist under that name
  if (!orgId) {
    return notFound();
  }

  const organizationAssets = await getOrganizationAssetsForOrg(orgId);

  const primaryColor = organizationAssets?.primaryColor;
  const primaryBackgroundColor = organizationAssets?.primaryBackgroundColor;
  const secondaryBackgroundColor = organizationAssets?.secondaryBackgroundColor;
  const secondaryColor = organizationAssets?.secondaryColor;

  const categories = await getCategories(orgId).then((categories) =>
    categories
      .sort((a, b) => b.popularity - a.popularity)
      .filter((category) => category.name === props.categoryName),
  );

  if (!categories?.length) {
    return null;
  }

  const products = await getProductsByCategoryId(
    categories.map((category) => category.id),
  );

  if (!products?.length) {
    return null;
  }

  return (
    <ProductCardCarousel
      products={products.sort((a, b) => b.popularity - a.popularity)}
      clientSlug={params.clientSlug}
      primaryColor={primaryColor}
      primaryBackgroundColor={primaryBackgroundColor}
      secondaryBackgroundColor={secondaryBackgroundColor}
      categoryName={props.categoryName}
      showIcon={props.showIcon}
      iconURL={props.iconURL}
      orgId={orgId}
    />
  );
}
